exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1FqjT0wfl-IAe8{cursor:pointer;display:block;text-decoration:none;background:#fff;padding:8px;width:239px;border-radius:3px}._3SkCIayaPXiBEk{margin:8px 0 0}.S66_jwmRIjlVND{font-size:12px;line-height:16px;color:#5e6c84;margin:4px 0 0}._2ew5me7OtK87qu{height:80px;width:auto;border-radius:3px;position:relative}._2ew5me7OtK87qu:hover{box-shadow:0 4px 8px rgba(9,30,66,.25);transition:opacity .2s ease-in-out}._2SOntjvvMUuoRA{font-size:14px;line-height:20px;color:#172b4d;font-weight:700;margin:16px 0 0}._3MiTEtWZuFoeo8{position:absolute;bottom:-12px;left:8px;line-height:12px}._2TXZ59awHWI5hH{background-color:#fff;border:3px solid #fff;box-shadow:0 1px 1px rgba(9,45,66,.25)}._3KJIyTe0qChuJq{border-radius:3px}", ""]);

// exports
exports.locals = {
	"container": "_1FqjT0wfl-IAe8",
	"copyButton": "_3SkCIayaPXiBEk",
	"secondaryText": "S66_jwmRIjlVND",
	"templateBackground": "_2ew5me7OtK87qu",
	"title": "_2SOntjvvMUuoRA",
	"memberAvatar": "_3MiTEtWZuFoeo8",
	"avatar": "_2TXZ59awHWI5hH",
	"orgAvatar": "_3KJIyTe0qChuJq"
};